import React from "react";
import { motion } from "framer-motion";

/**
 * DashboardGlow - Animated background blobs for a premium dashboard aesthetic.
 * Best used behind a content container with relative positioning.
 */
const DashboardGlow = () => {
    return (
        <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden">
            {/* Top Right Blob */}
            <motion.div
                animate={{
                    x: [0, 40, 0],
                    y: [0, -60, 0],
                    scale: [1, 1.1, 1],
                }}
                transition={{
                    duration: 15,
                    repeat: Infinity,
                    ease: "easeInOut",
                }}
                className="absolute top-[-10%] right-[-5%] w-[40vw] h-[40vw] bg-indigo-200/20 blur-[120px] rounded-full"
            />

            {/* Middle Left Blob */}
            <motion.div
                animate={{
                    x: [0, -30, 0],
                    y: [0, 50, 0],
                    scale: [1.1, 1, 1.1],
                }}
                transition={{
                    duration: 20,
                    repeat: Infinity,
                    ease: "easeInOut",
                }}
                className="absolute top-[30%] left-[-10%] w-[35vw] h-[35vw] bg-blue-200/20 blur-[100px] rounded-full"
            />

            {/* Bottom Right Blob */}
            <motion.div
                animate={{
                    x: [0, -50, 0],
                    y: [0, -30, 0],
                    scale: [1, 1.2, 1],
                }}
                transition={{
                    duration: 18,
                    repeat: Infinity,
                    ease: "easeInOut",
                }}
                className="absolute bottom-[-10%] right-[10%] w-[45vw] h-[45vw] bg-emerald-200/15 blur-[140px] rounded-full"
            />
        </div>
    );
};

export default DashboardGlow;
